import { Link } from 'react-router-dom';
import { GetStartedDialog } from '@/components/landing/GetStartedDialog';
import ivLogomark from '@/assets/iv-talent-logomark.png';

function FooterLogo() {
  return (
    <Link to="/" className="flex items-center gap-2.5 group shrink-0">
      <img src={ivLogomark} alt="IV Talent" className="hidden sm:block h-8 w-8 rounded-md" />
      <span className="font-display text-[20px] tracking-tight whitespace-nowrap text-ink">
        CultureLens
      </span>
    </Link>
  );
}

export function SiteFooter() {
  const cols = [
    {
      title: 'Product',
      links: [
        { label: 'Confidentiality', href: '/#trust' },
        { label: 'How it works', href: '/#how-it-works' },
        { label: 'Sign in', href: '/auth/signin', internal: true },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: "Who it's for", href: '/who-we-are#who-its-for', internal: true },
        { label: 'About', href: '/who-we-are#about', internal: true },
        { label: 'Talk to us', href: '/who-we-are#contact', internal: true },
        { label: 'Request access', href: '#', cta: true },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Legal notice', href: '/legal', internal: true },
        { label: 'Privacy policy', href: '/privacy', internal: true },
      ],
    },
  ];

  return (
    <footer className="bg-cream border-t border-hairline pt-20 pb-10">
      <div className="max-w-content mx-auto px-6 sm:px-10">
        <div className="grid md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-4">
            <FooterLogo />
            <p className="mt-5 font-grotesk text-charcoal/70 max-w-xs leading-relaxed">
              Early warning on the people risks that cost you money.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <div className="text-[11px] uppercase tracking-[0.18em] font-grotesk text-charcoal/50 mb-4">
                {c.title}
              </div>
              <ul className="space-y-3">
                {c.links.map((l: any) =>
                  l.cta ? (
                    <li key={l.label}>
                      <GetStartedDialog>
                        <button className="font-grotesk text-charcoal hover:text-ink transition-colors text-left">
                          {l.label}
                        </button>
                      </GetStartedDialog>
                    </li>
                  ) : l.internal ? (
                    <li key={l.label}>
                      <Link
                        to={l.href}
                        className="font-grotesk text-charcoal hover:text-ink transition-colors"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ) : (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        className="font-grotesk text-charcoal hover:text-ink transition-colors"
                      >
                        {l.label}
                      </a>
                    </li>
                  ),
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-hairline pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs font-grotesk text-charcoal/55">
            © {new Date().getFullYear()} CultureLens by IV Talent. All rights reserved.
          </p>
          <p className="text-xs font-grotesk text-charcoal/55">
            Confidential. Aggregated. Never identified.
          </p>
        </div>
      </div>
    </footer>
  );
}
